import type { FaireProductEntity } from "../../entity_types/product";

export const p_k5bk8exzkn: FaireProductEntity = {
  token: "p_k5bk8exzkn",
  type: "product",
  name: "14K GOLD STAINLESS STEEL SET ZIRCON STAR OPEN RING_CWAJE1223",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/b0934ff941acc6ed27a09c240b619462fb299e73b996eeea54113d206e9ae1e0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4265fad51810cac21e168a635dc5a940f8b895f5c6f2c6b2b18eafd6bcf1551.jpeg",
    "https://cdn.faire.com/fastly/7f5857ac6ae69dbfcd49f601cd408bd47319a8f0d6cd0ec1cec23d390a3f3f69.jpeg",
    "https://cdn.faire.com/fastly/6b791e1a9a9caa8c6bee09b85f544742057fe70656412be6df09f604b944dd10.jpeg",
    "https://cdn.faire.com/fastly/4965a19b6270bc77a4766a933410f29e408abcc5e061185dfca9469b0798e5ba.jpeg",
    "https://cdn.faire.com/fastly/e3c58c9af41a044a4edf46d614c634fdd5c299e7c4bb08d7d04a65d5e30023e6.jpeg",
    "https://cdn.faire.com/fastly/3751b2df4c75cb3d65496b15b4ce4d98ea143d67cbfc8f92ffd4a4f49481971e.jpeg",
    "https://cdn.faire.com/fastly/54c797dc276df48c5a0b9234471ecdd1dfb40147ab7ccb485dee5cddc5e2c667.jpeg",
    "https://cdn.faire.com/fastly/e41db7c330312a2353370165e244787292f5eee0c5c16bed439951be8aee7601.jpeg",
    "https://cdn.faire.com/fastly/01c4c262f067d5a56d56ae90017e142c46cd8f60ec340eb97f4964724e647684.jpeg",
  ],
  priceDollars: 13.84,
  description:
    "14K GOLD STAINLESS STEEL SET ZIRCON STAR OPEN RING\nSIZE:OS (1)\n100% STAINLESS STEEL\nMADE IN CHINA\n\nRINGS,RINGS BULK,RINGS STERLING SILVER,RINGS ADJUSTABLE,RINGS WITH STONES,RINGS FOR WOMEN,RINGS TURQUOISE,RINGS 14K,RINGS GOLD,RINGS DISPLAY,GOLD PLATED RINGS,14K GOLD PLATED RING,18K GOLD PLATED RINGS,CZ CENTER GOLD PLATED RING,ADJUSTABLE GOLD PLATED RING,HIGH-QUALITY GOLD PLATED RINGS,K GOLD PLATED RING,DIAMOND RING 14K,DIAMOND RING RING,DIAMOND RINGS WITH SOLITAIRE SETTING,DIAMOND RING GOLD,DIAMOND RINGS WITH HALO SETTING,DIAMOND RING GUARD,NATURAL STONE RINGS,NATURAL STONE RINGS JEWELRY",
  tags: [],
  msrpDollars: 27.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:46.492Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
